// SearchView is a class because this way we can reuse the functions in this class in different contexts.
class SearchView {
  #parentElement = document.querySelector(".search");

  // this function gets the text value of
  getQuery() {
    const field = this.#parentElement.querySelector(".search__field").value;
    // clearing input field
    this.#parentElement.querySelector(".search__field").value = "";

    return field;
  }

  addHandlerSearch(handler) {
    this.#parentElement.addEventListener("submit", function (e) {
      e.preventDefault();

      handler(); // handler is  controlSearchResults() from controller.js
    });
  }
}
export default new SearchView();
